export enum LogType {
  info = 'info',
  error = 'error',
  warning = 'warning',
}

// @ts-ignore
const isLogEnabled = __DEV__;

const appLog = (
  type: LogType = LogType.info,
  message?: any,
  ...optionalParams: any[]
) => {
  if (!isLogEnabled) {
    return;
  }

  switch (type) {
    case LogType.error:
      // eslint-disable-next-line no-console
      console.error('easy: ', message, ...optionalParams);
      break;
    case LogType.warning:
      // eslint-disable-next-line no-console
      console.warn('easy: ', message, ...optionalParams);
      break;
    default:
      // eslint-disable-next-line no-console
      console.log('easy: ', message, ...optionalParams);
  }
};

const log = (message?: any, ...optionalParams: any[]) => {
  appLog(LogType.info, message, ...optionalParams);
};

const error = (message?: any, ...optionalParams: any[]) => {
  appLog(LogType.error, message, ...optionalParams);
};

export const logger = {
  log,
  error,
};
